/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import * as Sentry from "@sentry/vue";

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo)

let APP_ENV = document.head.querySelector('meta[name="app-env-val"]');
if(APP_ENV && APP_ENV.content == 'production') {
    Sentry.init({
        Vue,
        dsn: "https://f0c0445999b143d0a075882b922e2d0f@o47613.ingest.sentry.io/6761261",
        integrations: [],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        // tracesSampleRate: 1.0,
    });
} else if(APP_ENV && APP_ENV.content == 'testing') {
    Sentry.init({
        Vue,
        dsn: "https://85a5735234954a249b1a7f68e978a4ab@o47613.ingest.sentry.io/6455173",
        integrations: [],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        // tracesSampleRate: 1.0,
    });
}


// Draggable
import draggable from 'vuedraggable'
Vue.component('draggable', draggable);

import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component('vue-cropper', VueCropper);

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.component('flatPickr', flatPickr);

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
Vue.component('VueTimepicker', VueTimepicker);

import 'jodit/build/jodit.min.css'
import JoditVue from 'jodit-vue'
Vue.use(JoditVue)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)

// import Datepicker from 'vuejs-datepicker';
// Vue.component('Datepicker', Datepicker);

// Vee Validate
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

// No message specified.
extend('email', email);

// Override the default message.
extend('required', {
    ...required,
    message: 'This field is required'
});
// Override the default message.
extend('email', {
    ...email,
    message: 'Please use a valid email address'
});
extend('requiredArray', {
    validate (value) {
        return !_.isEmpty(value)
    },
    message: 'This field is required',
    computesRequired: true
});
// Register it globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
// End of Vee Validate Stuff

Vue.use(require('vue-moment'));

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.config.devtools = true;
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('flash-alert', require('./components/FlashAlert.vue').default);
Vue.component('error-message', require('./components/ErrorMessage.vue').default);

Vue.component('order-delete', require('./components/OrderDelete.vue').default);
Vue.component('signature-pad', require('./components/SignaturePad.vue').default);

Vue.component('instructions', require('./components/Instructions.vue').default);
Vue.component('create-entry-order', require('./components/EntryCreateOrder.vue').default);
Vue.component('entries-table', require('./components/EntriesTable').default);
Vue.component('admin-search', require('./components/AdminSearch').default);
Vue.component('marketing-search', require('./components/MarketingSearch').default);
Vue.component('question-popup', require('./components/QuestionPopup').default);

Vue.component('admin-change-user', require('./components/AdminChangeUser.vue').default);
Vue.component('admin-internal-notes', require('./components/AdminInternalNotes').default);
Vue.component('admin-entry-faculty-resend', require('./components/AdminFacultyResend.vue').default);
Vue.component('video-component-upload', require('./components/VideoUploadComponent.vue').default);
Vue.component('video-player', require('./components/VideoPlayer.vue').default);
Vue.component('video-player-in-modal', require('./components/VideoPlayerInModal.vue').default);
Vue.component('email-faculty', require('./components/EmailFaculty.vue').default);
Vue.component('modal', require('./components/Modal.vue').default);
Vue.component('file-upload-component', require('./components/FileUpload.vue').default);
Vue.component('image-upload-component', require('./components/ImageUpload.vue').default);
Vue.component('image-upload-component-entrant-block', require('./components/ImageUploadEntrantBlock.vue').default);

// Icons
Vue.component('editicon', require('./components/icons/edit.vue').default);
Vue.component('saveicon', require('./components/icons/save.vue').default);
Vue.component('uploadicon', require('./components/icons/upload.vue').default);
Vue.component('caret_right', require('./components/icons/caret_right.vue').default);
Vue.component('circle_check', require('./components/icons/circle_check.vue').default);

// Added for CTA
Vue.component('video-upload-on-behalf', require('./components/VideoUploadOnBehalf.vue').default);
Vue.component('entry-title', require('./components/EntryTitle.vue').default);
Vue.component('signature-block', require('./components/SignatureBlock.vue').default);
Vue.component('judgement-save', require('./components/JudgementSave.vue').default);
Vue.component('entrant-block', require('./components/EntrantBlock.vue').default);
Vue.component('university-list', require('./components/UniversityList.vue').default);
Vue.component('panels-list', require('./components/PanelsList.vue').default);
Vue.component('admin-video-updates', require('./components/AdminVideoUpdates.vue').default);
Vue.component('admin-entry-updates', require('./components/AdminEntryUpdates.vue').default);
Vue.component('admin-entry-updates-with-key-value', require('./components/AdminEntryUpdateWithKeyValue.vue').default);
Vue.component('category-clone', require('./components/CategoryClone.vue').default);
Vue.component('category-delete', require('./components/CategoryDelete.vue').default);
Vue.component('entry-form-next-prev-admin', require('./components/EntryFormNextPrevAdmin.vue').default);
Vue.component('note-editor', require('./components/NoteEditor.vue').default);
Vue.component('users-table', require('./components/UsersTable.vue').default);

Vue.component('category-builder', require('./components/CategoryBuilder.vue').default);
Vue.component('category-builder-layout-judge', require('./components/CategoryBuilderLayoutJudge.vue').default);
Vue.component('category-builder-item', require('./components/CategoryBuilderItem.vue').default);
Vue.component('password-reset-modal', require('./components/PasswordResetModal.vue').default);
Vue.component('remove-entry-from-panel', require('./components/RemoveEntryFromPanel.vue').default);
Vue.component('judging-panels', require('./components/JudgingPanels.vue').default);

// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//     Vue,
//     dsn: "https://d2b12316586447d0a39d5dc1ca2f5bd6@o47613.ingest.sentry.io/1828252",
//     integrations: [new Integrations.BrowserTracing()],
//
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.1,
// });

import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

const app = new Vue({
    el: '#app',
    components: {vueDropzone},
    data() {
        return {
            filename: '',
            showLogout: false,
            showMessage: true,
            date_config: {dateFormat: 'm-d-Y'},
            alertShow: false,
            signatureNeeded: '',
            panelReadyToSubmit: true,
            deleteModal: false,
            updateAllowed: $('#entry-form-wrapper').attr('data-update_allowed'),
            signature: $('#signature-block').data('signature'),
            showVideoUploader: false,
            role: '',
            actionUrl: $('form#entry-form-submit').attr('action'),
            updateFormQueue: [],
            updateFormProcessing: false,
            wordCountObject: {
                'video_plot_summary': {
                    'maxWords': Number($('.video_plot_summary .max_words').text()),
                    'number_over': '',
                    'showWordCountMax': false,
                    'text': $('#video_plot_summary').val(),
                },
                'video_plot_summary_2': {
                    'maxWords': Number($('.video_plot_summary_2 .max_words').text()),
                    'number_over': '',
                    'showWordCountMax': false,
                    'text': $('#video_plot_summary_2').val()
                },
                'video_plot_summary_3': {
                    'maxWords': Number($('.video_plot_summary_3 .max_words').text()),
                    'number_over': '',
                    'showWordCountMax': false,
                    'text': $('#video_plot_summary_3').val()
                },
                'logline': {
                    'maxWords': Number($('.logline .max_words').text()),
                    'number_over': '',
                    'showWordCountMax': false,
                    'text': $('#logline').val()
                },
            }
        }
    },
    computed: {
        updateIsInProgress() {
            return this.updateFormProcessing || this.updateFormQueue.length > 0;
        },
    },
    mounted() {
        this.role = $('#role').attr('data-role');

        if(this.updateAllowed == 'false') {
            // Convert items we can to readonly
            $('#entry-form-wrapper').find('input, textarea').prop('readonly', true);
        }
    },
    methods: {
        showFlashAlert: function() {
            this.alertShow = true;
        },
        signatureNeededPopover: function() {
            let that = this;
            if(this.updateAllowed == 'false') {
                return false;
            }
            $('.html').addClass('overlay');
            that.signatureNeeded = true;
        },
        closeModal: function() {
            $('.html').removeClass('overlay');
            this.signatureNeeded = false;
        },
        saveSignature: function(signature) {
            let app = this;
            app.signature = signature;
            app.signatureNeeded = false;
            window.axios(
                {
                    method: 'post',
                    url: app.actionUrl,
                    data: {
                        signature: app.signature,
                    }
                }).then(function(response) {
                console.log('updated form')
            }).catch(function (error) {
                // handle error
                console.log('This is the error returned',error);
                app.notifyUploaderStatus = 'error';
                app.notifyUploaderStatusMessage = 'Error: '+error.message;
            });
        },
        showVideoUploadComponent: function(video_component_status) {
            this.showVideoUploader = video_component_status;
        },
        updateForm: function(event, key) {
            let that = this;
            if(that.role == 'admin') {
                return;
            }

            let value = event.target.value;

            const signatures_checkbox_fields = ["box_1", "box_2", "box_3", "box_4"];
            if(signatures_checkbox_fields.includes(key)) {
                value = event.target.checked ? '1' : '0';
            }

            if($(event.target).closest('.form-field-wrapper').hasClass('required') && event.target.value != '') {
                $(event.target).closest('.form-field-wrapper').removeClass('required');
            }

            this.updateFormQueue.push({
                [key]: value,
            });
            this.processUpdateFormQueue();
        },
        processUpdateFormQueue() {
            if (this.updateFormProcessing || this.updateFormQueue.length === 0) {
                return;
            }

            this.updateFormProcessing = true;
            const updateData = this.updateFormQueue.shift();

            window.axios({
                    method: 'post',
                    url: this.actionUrl,
                    data: updateData
            }).then(function(response) {
                // No need to do anything here, silent auto-save
            }).catch(function (error) {
                console.log('This is the error returned',error);
                this.notifyUploaderStatus = 'error';
                this.notifyUploaderStatusMessage = 'Error: '+error.message;
            }).finally(() => {
                this.updateFormProcessing = false;
                this.processUpdateFormQueue();
            });
        },
        updateFormAdmin: function() {
            let that = this;
            if(that.role != 'admin') {
                return;
            }

            let adminActionUrl = $('form#entry-full-form-wrapper-submit').attr('action');
            let dataVal = $('#entry-full-form-wrapper-submit').serialize();
            window.axios(
                {
                    method: 'post',
                    url: adminActionUrl,
                    data: dataVal
                }).then(function(response) {
                // Admin save Entrant Block
                that.$refs.EntrantBlock.saveAllEntrants();
            }).catch(function (error) {
                // handle error
                console.log('This is the error returned',error);
                that.notifyUploaderStatus = 'error';
                that.notifyUploaderStatusMessage = 'Error: '+error.message;
            });
        },
        checkRequiredAndSubmit: function() {
            let app = this;
            app.checkRequired();
          },
        checkRequired: function() {
            let app = this;
            let passedValidation = true;
            $('#entry-form-wrapper .form-control').each(function(i,v) {
                let that =  this;
                if (that.required) {
                    if (($(that).attr('type') == 'checkbox') || ($(that).attr('type') == 'radio')) {
                        let name = $(that).attr('name');
                        if(!$("input[name='"+name+"']").is(':checked')) {
                            that.required = true;
                            $(that).closest('.form-field-wrapper').addClass('required');
                            passedValidation = false;
                        } else {
                            $(that).closest('.form-field-wrapper').removeClass('required');
                        }
                    } else if($(that).attr('type') == 'email') {
                        if (!app.validateEmail($.trim($(that).val()))) {
                            $(that).closest('.form-field-wrapper').addClass('required');
                            passedValidation = false;
                        }
                    } else if (_.trim(that.value) == '') {
                        $(that).closest('.form-field-wrapper').addClass('required');
                        passedValidation = false;
                    }
                }
            });

            let videoFieldsComplete = app.$refs.videoComponent.underlineFields();

            // Confirm Entrant Block, Video Block and File Uploads have fields when needed.
            let entrantFieldsComplete = app.$refs.EntrantBlock.underlineFields();

            let fileUploadFieldsComplete = true;
            $('.file-wrapper').each(function(i,v) {
                var refName = $(this).attr('data-fieldname');
                if(!app.$refs[refName].underlineFields()) {
                    fileUploadFieldsComplete = false;
                }
            });

            let wordCountUnderMaximum = true;
            $('textarea.form-control.has_word_count_max').each(function(value, index) {
               let machine_name = $(this).attr('name');
               app.wordCountFixer($(this).val(), machine_name);
               if(app.wordCountObject[machine_name].number_over > 0) {
                   wordCountUnderMaximum = false;
                   $(this).closest('.form-group-beside').addClass('required');
               }
            });

            if(passedValidation && entrantFieldsComplete && fileUploadFieldsComplete && videoFieldsComplete && wordCountUnderMaximum) {
                app.submitEntryData();
            } else {
                app.$scrollTo('#top-of-form', 700);
                app.alertShow = true;
                if(!videoFieldsComplete) {
                    // console.log('jeffffff')
                }
            }
        },
        submitEntryData: function() {
            $('#entry-form-submit').submit();
        },
        wordCountFixer: function(value, index) {
            let text = value;
            let app = this;
            if(text != null) {
                let numberWords = app.wordCounter(text);
                if (numberWords > app.wordCountObject[index].maxWords) {
                    app.wordCountObject[index].number_over = numberWords - app.wordCountObject[index].maxWords;
                    app.wordCountObject[index].showWordCountMax = true;
                } else {
                    app.wordCountObject[index].number_over = 0;
                    app.wordCountObject[index].showWordCountMax = false;
                }
            }
        },
        wordCounter: function(s){
            s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
            s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
            s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
            return s.split(' ').length;
        },
        validateEmail: function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        clearSubmitterCache: function(ev) {
            localStorage.removeItem('CTA-history-search');
            localStorage.removeItem('CTA-history-search-status');
            localStorage.removeItem('CTA-history-search-filestatus');
            localStorage.removeItem('CTA-history-search-type');
            localStorage.removeItem('CTA-history-search-sort');
            localStorage.removeItem('CTA-history-search-sort-order');
            localStorage.removeItem('CTA-history-search-num');
            localStorage.removeItem('CTA-history-search-page');
            window.location = $(ev.target).attr('href')
        },
        rowHrefRedirect(hrefVal) {
            window.location.href = hrefVal;
        }
    }
});

window.countWords = function(s){
    s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
    s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
    s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
    return s.split(' ').length;
}
